import { render, staticRenderFns } from "./VuesticTabs.vue?vue&type=template&id=4fd3bb00&"
import script from "./VuesticTabs.vue?vue&type=script&lang=js&"
export * from "./VuesticTabs.vue?vue&type=script&lang=js&"
import style0 from "./VuesticTabs.vue?vue&type=style&index=0&id=4fd3bb00&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports